import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.state';

export const selectUiState = createFeatureSelector<UiState>('ui');

export const selectReportSidebar = createSelector(
  selectUiState,
  (state: UiState) => state.reportSidebar
);

export const selectReportSidebarTabs = createSelector(
  selectReportSidebar,
  (reportSidebar) => reportSidebar.tabs
);

export const selectActiveTabIndex = createSelector(
  selectReportSidebar,
  (reportSidebar) => reportSidebar.activeTabIndex
);

export const selectIsAsideOpen = createSelector(
  selectUiState,
  (state) => state.aside.isOpen
);

export const selectIsClosing = createSelector(
  selectReportSidebar,
  (reportSidebar) => reportSidebar.isClosing
);

export const selectIsDarkMode = createSelector(
  selectUiState,
  (state) => state.theme.isDarkMode
);

export const selectSidebar = createSelector(
  selectUiState,
  (state: UiState) => state.sidebar
);

export const selectIsSidebarCollapsed = createSelector(
  selectSidebar,
  (sidebar) => sidebar.isCollapsed
);

// Banner selectors
export const selectBannerState = createSelector(
  selectUiState,
  (state: UiState) => state.banner
);

export const selectIsSubscriptionBannerVisible = createSelector(
  selectBannerState,
  (state) => state.isSubscriptionVisible
);
